"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const advanto_logo_svg_1 = __importDefault(require("@app/image/advanto-logo.svg"));
const alveno_logo_svg_1 = __importDefault(require("@app/image/alveno-logo.svg"));
const baris_logo_svg_1 = __importDefault(require("@app/image/baris-logo.svg"));
const humanhours_logo_svg_1 = __importDefault(require("@app/image/humanhours-logo.svg"));
const ks_logo_svg_1 = __importDefault(require("@app/image/ks-logo.svg"));
const lunchdrive_logo_svg_1 = __importDefault(require("@app/image/lunchdrive-logo.svg"));
const mrp_logo_svg_1 = __importDefault(require("@app/image/mrp-logo.svg"));
const Okbase_logo_svg_1 = __importDefault(require("@app/image/Okbase-logo.svg"));
const pamica_logo_svg_1 = __importDefault(require("@app/image/pamica-logo.svg"));
const perm_logo_svg_1 = __importDefault(require("@app/image/perm-logo.svg"));
const pinya_logo_svg_1 = __importDefault(require("@app/image/pinya-logo.svg"));
const reservio_logo_svg_1 = __importDefault(require("@app/image/reservio-logo.svg"));
const rsm_logo_svg_1 = __importDefault(require("@app/image/rsm-logo.svg"));
const react_1 = __importDefault(require("react"));
const plugins = Object.freeze([
    {
        id: 'calendar',
        isExternal: false,
        requireEnabled: true,
        icon: 'calendar-outlined',
        settings: '/settings/employee-preferences',
    },
    {
        id: 'attendance',
        isExternal: false,
        icon: 'attendance',
        settings: '/backoffice/attendance',
    },
    {
        id: 'terminal',
        isExternal: false,
        icon: 'check-in',
        settings: '/backoffice/terminals',
    },
    {
        id: 'offers',
        isExternal: false,
        icon: 'offer',
        settings: '/settings/contest-settings',
    },
    {
        id: 'chat',
        isExternal: false,
        onlyOnRequest: false,
        icon: 'chat',
        customUninstallMessageKey: 'PLUGIN_DEACTIVATE_MESSAGE.chat',
    },
    {
        id: 'reports',
        isExternal: false,
        icon: 'report',
        settings: '/backoffice/reports',
    },
    {
        id: 'laborlaw',
        isExternal: false,
        icon: 'law',
        settings: '/settings/employee-preferences',
    },
    {
        id: 'communication',
        isExternal: false,
        icon: 'comment',
    },
    {
        id: 'standby',
        isExternal: false,
        icon: 'standby-plugin',
        settings: '/workspace/attributes',
    },
    {
        id: 'capacityplanning',
        isExternal: false,
        icon: 'capacity',
        settings: '/settings/capacities',
    },
    {
        id: 'apikeys',
        isExternal: false,
        icon: 'api',
        settings: '/workspace/api-keys',
    },
    {
        id: 'mfa',
        isExternal: false,
        onlyOnRequest: false,
        icon: 'lock',
        settings: '/workspace',
    },
    {
        id: 'dayswapspro',
        name: 'Dayswaps Pro',
        isExternal: false,
        onlyOnRequest: true,
        icon: 'dayswaps',
        settings: '/organization',
    },
    // EXTERNAL
    {
        id: 'okbase',
        name: 'OKBase',
        isExternal: true,
        onlyOnRequest: true,
        logo: react_1.default.createElement(Okbase_logo_svg_1.default, null),
        preventsFunctions: [
            'addEmployee',
            'editJobPositions',
            'assignJobPositions',
            'editEmployeeContracts',
            'editEmployeeDataBirthDate',
            'pluginActivateDeactivate',
        ],
    },
    {
        id: 'ksportal',
        isExternal: true,
        onlyOnRequest: true,
        logo: react_1.default.createElement(ks_logo_svg_1.default, null),
        preventsFunctions: [
            'addEmployee',
            'editJobPositions',
            'assignJobPositions',
            'editEmployeeContracts',
            'editEmployeeDataVacationDays',
            'editEmployeeRoleType',
            'terminateEmployee',
            'pluginActivateDeactivate',
            'editUnavailabilityCategories',
            'editWorkspaceName',
            'editWorkspaceBalancingPeriod',
            'editWorkspaceOffers',
        ],
    },
    {
        id: 'pamica',
        name: 'Pamica',
        isExternal: true,
        onlyOnRequest: true,
        logo: react_1.default.createElement(pamica_logo_svg_1.default, null),
    },
    {
        id: 'advanto',
        name: 'Advanto',
        isExternal: true,
        onlyOnRequest: true,
        logo: react_1.default.createElement(advanto_logo_svg_1.default, null),
    },
    /* {
  id: 'palmapp',
  isExternal: true,
  onlyOnRequest: true,
  logo: <PalmAppLogo />
}, */
    {
        id: 'lunchdrive',
        name: 'Lunchdrive',
        isExternal: true,
        onlyOnRequest: true,
        logo: react_1.default.createElement(lunchdrive_logo_svg_1.default, null),
    },
    {
        id: 'perm',
        name: 'Perm',
        isExternal: true,
        onlyOnRequest: true,
        logo: react_1.default.createElement(perm_logo_svg_1.default, null),
    },
    {
        id: 'alveno',
        name: 'Alveno',
        isExternal: true,
        onlyOnRequest: true,
        logo: react_1.default.createElement(alveno_logo_svg_1.default, null),
        preventsFunctions: [
            'pluginActivateDeactivate',
            'editUnavailabilityCategories',
            'editWorkspaceOffers',
            'editJobPositions',
            'assignJobPositions',
        ],
    },
    {
        id: 'baris',
        name: 'Baris',
        isExternal: true,
        onlyOnRequest: true,
        logo: react_1.default.createElement(baris_logo_svg_1.default, null),
    },
    {
        id: 'reservio',
        name: 'Reservio',
        isExternal: true,
        onlyOnRequest: true,
        logo: react_1.default.createElement(reservio_logo_svg_1.default, null),
    },
    {
        id: 'pinya',
        name: 'Pinya',
        isExternal: true,
        onlyOnRequest: true,
        logo: react_1.default.createElement(pinya_logo_svg_1.default, null),
    },
    {
        id: 'mrp',
        name: 'MRP',
        isExternal: true,
        onlyOnRequest: true,
        logo: react_1.default.createElement(mrp_logo_svg_1.default, null),
    },
    {
        id: 'humanhours',
        name: 'Human Hours',
        isExternal: true,
        onlyOnRequest: true,
        logo: react_1.default.createElement(humanhours_logo_svg_1.default, null),
    },
    {
        id: 'rsm',
        name: 'RSM',
        isExternal: true,
        onlyOnRequest: true,
        logo: react_1.default.createElement(rsm_logo_svg_1.default, null),
    },
].map((item, index) => ({ ...item, sortId: index + 1 })));
const pluginNames = {};
plugins.forEach((item) => {
    pluginNames[item.id.toUpperCase()] = item.id;
});
exports.default = {
    SUPPORTED_PLUGINS: plugins,
    NAMES: pluginNames,
};
